const transformArrayToObject = (list) => {
    const obj = {};
    list.forEach((e) => {
        obj[`${e.id}`] = e;
    });
    return obj;
};

export default transformArrayToObject